module.exports = __webpack_public_path__ + "img/KSC05728.824228be.jpg";